import * as Style from "../style/StyledComponents";
import { abbreviateAddress, chain, contractAddress, getEtherscanAddressLink, getEtherscanTxnLink, getEtherscanContractLink, links } from "./Config";
import {useState, useEffect} from 'react'
import { useQueryClient } from '@tanstack/react-query'

//import { InjectedConnector } from 'wagmi/connectors/injected'
import { useConnect , useAccount, useDisconnect, useBalance, useChainId, useSwitchChain } from 'wagmi'
import { usePrepareContractWrite, useWriteContract  , useReadContracts  } from 'wagmi'
//import { waitForTransaction, fetchBalance  } from '@wagmi/core'

import { injected } from 'wagmi/connectors'
import { ethers } from 'ethers';
import BigNumber from 'bignumber.js';

BigNumber.config({ EXPONENTIAL_AT: 50 })

const contractABI_MintFrontEnd = require("../abi/Skulls.json");

const frontendContract = {
  address: contractAddress,
  abi: contractABI_MintFrontEnd.abi,
}


const MINT_STATUS = {
  DISABLED:0,
  WHITELIST:1,
  PUBLIC:2
}

const MINT_STRING = [ "❌Disabled", "📝Whitelist Only", "Public"];

export const Mint = () => {

  const queryClient = useQueryClient();

  const { isConnected , address, chainId : walletChainId } = useAccount()
  const { disconnect } = useDisconnect()
  const { connect } = useConnect();
  //const {walletChainId} = useChainId();
  const { switchChain } = useSwitchChain();

  // pulled onchain
  const [publicPrice, setPublicPrice] = useState("1");
  const [allowlistPrice, setAllowlistPrice] = useState("1");

  const [currentSupply, setCurrentSupply] = useState(0);
  const [maxSupply, setMaxSupply] = useState(1111);
  const [mintPrice, setMintPrice] = useState("1");
  const [mintCount, setMintCount] = useState(1);
  const [mintStatus, setMintStatus] = useState(0);
  const [maxMintAmount, setMaxMintAmount] = useState(0);
  const [maxMintAmountRemaining, setMaxMintAmountRemaining] = useState(0);
  const [maxPerWalletPublic, setMaxPerWalletPublic] = useState(0);
  const [allowlistedAmount, setAllowlistedAmount] = useState(0);
  
  // per user
  const [addressIsWhitelisted, setAddressIsWhitelisted] = useState(false);
  const [addressNumMinted, setAddressNumMinted] = useState(0);


  const [walletBalance, setWalletBalance] = useState("0.0");

  // calculated
  const [totalMintPrice, setTotalMintPrice] = useState("0.0");

  const { data:readData, isError:readError, isLoading:readIsLoading } = useReadContracts({
    query:{enabled: isConnected == true},
    contracts: [
      {
        ...frontendContract,
        functionName: 'totalSupply',
      },
      {
        ...frontendContract,
        functionName: 'MAX_SUPPLY',
      },
      {
        ...frontendContract,
        functionName: 'maxPerWallet',
      },
      {
        ...frontendContract,
        functionName: 'mintStatus',
      },
      {
        ...frontendContract,
        functionName: 'publicPrice',
      },
      {
        ...frontendContract,
        functionName: 'allowlistPrice',
      },

      {
        ...frontendContract,
        functionName: 'numMinted',
        args:[address],
      },

      {
        ...frontendContract,
        functionName: 'getNumMinted',
        args:[address],
      },

      {
        ...frontendContract,
        functionName: 'allowlist',
        args:[address],
      },

      {
        ...frontendContract,
        functionName: 'maxPerWalletPublic',
      },
    ],
  });

  const { data: balance, queryKey } = useBalance({ 
    address: address,
    watch: true, 
  });

  useEffect(()=>{

    if (balance != null && isConnected && address) {
      const price = new BigNumber(parseInt(balance.value));
      const total = price.multipliedBy("1E-18").toFixed(4);
      setWalletBalance(total);
    }
  }, [balance, isConnected]);

  useEffect(()=>{
    if (mintStatus == MINT_STATUS.WHITELIST) {
      setMintPrice(allowlistPrice);
    } else {
      setMintPrice(publicPrice);
    }
  }, [mintStatus, allowlistPrice, publicPrice]);


  useEffect(()=>{
    if (readData != null) {
      console.log("Contract read:", readData);

      setCurrentSupply( parseInt(readData[0].result));
      setMaxSupply( parseInt(readData[1].result));
      
      const mintStatus = parseInt(readData[3].result);
      setMintStatus(mintStatus);

      const price = new BigNumber(parseInt(readData[4].result));
      const total = price.multipliedBy("1E-18");
      setPublicPrice(total.toString());

      const allowlistPrice = new BigNumber(parseInt(readData[5].result));
      const totalAllowlist = allowlistPrice.multipliedBy("1E-18");
      setAllowlistPrice(totalAllowlist.toString());

      const addressIsWhitelisted = readData[8].result > 0;
      const allowlistedAmount = parseInt(readData[8].result);
      const maxPerWalletPublic = parseInt(readData[9].result);
      const addressNumMinted = parseInt(readData[7].result);

      setAddressNumMinted( addressNumMinted);
      setAddressIsWhitelisted( addressIsWhitelisted );
      setAllowlistedAmount( allowlistedAmount);
      setMaxPerWalletPublic(maxPerWalletPublic);

      switch (mintStatus) {
        case MINT_STATUS.WHITELIST:
          setMaxMintAmount( Math.max(allowlistedAmount, 0) );
          setMaxMintAmountRemaining( Math.max(allowlistedAmount-addressNumMinted, 0) );
          break;
        case MINT_STATUS.PUBLIC:
          setMaxMintAmount( Math.max(maxPerWalletPublic+allowlistedAmount, 0) );
          setMaxMintAmountRemaining( Math.max(maxPerWalletPublic-addressNumMinted, 0) );
          break;
        default:
          setMaxMintAmount(0);
          break;
      }
    }

  }, [readData]);


  const { data, isPending, isSuccess, error, isError, writeContract, reset } = useWriteContract ({
    address: contractAddress,
    abi: frontendContract.abi,
    functionName: mintStatus == MINT_STATUS.WHITELIST ? 'allowlistMint' : 'mint',
    args: [mintCount],
    chainId: chain.id,
    account: address,

    onSettled(data, error) {
      console.log('Transaction Settled', { data, error })
    },
  });

  useEffect(()=>{
    const price = new BigNumber(mintPrice);
    const total = price.multipliedBy(mintCount);
    setTotalMintPrice(total.toString());
  },  [mintPrice, mintCount]);


  function onClickPlus() {
    setMintCount(Math.min(maxMintAmount, mintCount+1));
  }

  function onClickMinus() {
    setMintCount(Math.max(1, mintCount-1));
  }

  function onClickConnect() {
    console.log("CONNECT");
    connect({connector:injected()});
  }

  function onClickDisconnect() {
    console.log("Disconnect");
    disconnect();
    reset();
  }

  async function onClickAddChain() {
    if (!window.ethereum) {
      console.error("No wallet provider found");
      return;
    }

    try {
      await window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainId: `0x${chain.id.toString(16)}`,
            chainName: chain.name,
            nativeCurrency: chain.nativeCurrency,
            rpcUrls: chain.rpcUrls?.default?.http ?? chain.rpcUrls?.public?.http ?? [],
            blockExplorerUrls: [chain.blockExplorers?.default?.url ?? chain.blockExplorers?.etherscan?.url].filter(Boolean),
          },
        ],
      });
    } catch (error) {
      console.error("Failed to add chain", error);
    }
  }

  async function onClickMint() {
    reset();

    console.log(`Minting: mint(${mintCount}) with payable ${totalMintPrice} ETH`);
    writeContract({
          address: contractAddress,
          abi: frontendContract.abi,
          functionName: mintStatus == MINT_STATUS.WHITELIST ? 'allowlistMint' : 'mint',
          chainId: chain.id,
          account: address,

          args: [mintCount],
          from: address,
          value: ethers.parseEther(totalMintPrice),
    });
  }

  return (
    <div>

      {/*<p>chainid: {walletChainId}, target: {chain.id}</p>*/}

    <>
        <Style.Button disabled>Minted Out!</Style.Button>
        <p style={{fontSize:"0.75em", marginTop:"5px"}}>✔️ 2222/2222 
          <br/>
           ( View on <a href={links.opensea} target="_blank">OpenSea</a> )
        </p>
      </>
  

{/*
{!isConnected && <><br/><p>- Summon -</p><Style.Button onClick={onClickConnect}>- Connect -</Style.Button><p style={{fontSize:"0.7em", marginTop:"8px"}}>Network: <a href={links.megaeth} target="_blank">{chain.name}</a></p><br/></>}

    {isConnected && walletChainId !== chain.id && (
      <div style={{marginTop:"1em", textAlign:"center"}}>
        <Style.ErrorMessage>Wrong network. Please switch to {chain.name}.</Style.ErrorMessage>
        <Style.Button onClick={() => switchChain({ chainId: chain.id })}>Switch Network</Style.Button>
        <div style={{fontSize:"0.8em", marginTop:"0.6em"}}>If your wallet does not have {chain.name}, add it:</div>
        <Style.Button onClick={onClickAddChain}>Add {chain.name}</Style.Button>
      </div>
    )}

    {isConnected && walletChainId === chain.id && mintStatus==MINT_STATUS.DISABLED && <Style.Button disabled={true}>- Minting Not Available -</Style.Button>}
    {isConnected && walletChainId === chain.id && mintStatus!=MINT_STATUS.DISABLED && currentSupply == maxSupply && <Style.Button disabled={true}>- Minted Out -</Style.Button>}

    {isConnected && walletChainId === chain.id && mintStatus==MINT_STATUS.WHITELIST && !addressIsWhitelisted && currentSupply < maxSupply && <Style.Button disabled={true}>😥 Not Whitelisted</Style.Button>}
    {isConnected && walletChainId === chain.id && mintStatus!=MINT_STATUS.DISABLED && allowlistedAmount > 0 && currentSupply < maxSupply && addressNumMinted >= maxMintAmount && <Style.Button disabled={true}>- You've Max Minted -</Style.Button>}

    {isConnected && <div style={{marginTop:"1em", fontSize:"0.9em",textAlign:"center",}}>✅ <strong>Connected</strong>:<br/>🟢 <a href={getEtherscanAddressLink(address)} target="_blank">{abbreviateAddress(address,5)}</a> (<a onClick={onClickDisconnect} style={{cursor:"pointer"}}>Disconnect</a>)</div>}
    {isConnected && <div style={{fontSize:"0.9em",textAlign:"center",}}>- Your Balance: <strong>{walletBalance} {chain.nativeCurrency.symbol}</strong> -</div>}

    {isConnected && walletChainId === chain.id && (mintStatus==MINT_STATUS.PUBLIC || (mintStatus==MINT_STATUS.WHITELIST && addressIsWhitelisted) ) && currentSupply < maxSupply && addressNumMinted < maxMintAmount && 
      <div style={{textAlign:"center", margin:"2em 0"}}>

        <div style={{marginBottom:"0.5em", textAlign:"center"}}>
          
        <p style={{fontSize:"1em", fontWeight:"bold"}}> Total:<br/><span style={{fontSize:"1.5em", color: "yellow", fontWeight:"bold"}}>{totalMintPrice} {chain.nativeCurrency.symbol}</span></p>
        <p style={{marginLeft:"0.5em", fontSize:"0.65em"}}>= {mintCount}💀 x {mintPrice} {chain.nativeCurrency.symbol} each</p>

        </div>

          <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
            <Style.Button disabled={isPending || mintCount<=1} onClick={onClickMinus}>-</Style.Button>
            <Style.Button disabled={isPending} onClick={onClickMint}>Mint {mintCount}</Style.Button>
            <Style.Button disabled={isPending || mintCount>=maxMintAmountRemaining || (currentSupply+mintCount+1 > maxSupply) }  onClick={onClickPlus}>+</Style.Button>
          </div>



    </div>
      }

      */}
{isError && <Style.ErrorMessage>Error: {error.message}</Style.ErrorMessage>}



   {isConnected && 
      <div style={{marginTop:"1.2em", fontSize:"0.8em", textAlign:"center"}}>
        <h2>- Onchain State -</h2>
        ◦ Mint Status: <strong>{MINT_STRING[mintStatus]}</strong>
        <br/>
         ◦ Mint Price (each): <strong>{mintPrice} {chain.nativeCurrency.symbol}</strong>
         <br/> <br/> <br/>
        ◦ Total Minted: 💀{currentSupply==maxSupply?"✔️ ":""}<strong>{currentSupply} / {maxSupply}</strong>
        <br/> <br/> <br/>
        ◦ Num Minted by You: 💀<strong>{addressNumMinted} (of {maxMintAmountRemaining} remaining)</strong>
        <br/>
        ◦ You're Whitelisted: <strong>{addressIsWhitelisted ? "✔️ Yes" : "😥 No"}</strong> {addressIsWhitelisted && `(${allowlistedAmount} allowed for WL)`}

      </div>
    }




    {isSuccess && data != null && <Style.SuccessMessage><strong>✔️ Transaction Sent</strong>: <a href={getEtherscanTxnLink(data)} target="_blank">{abbreviateAddress(data, 7)}</a></Style.SuccessMessage>}
    </div>
  )
}
